import {NativeAuthClient} from "@multiversx/sdk-native-auth-client";
import {NetworkEnv} from "../common/types";
import {network} from "../config/network";


export const getAuthClient = () => {
    const env = process.env.NEXT_PUBLIC_NETWORK_ENV! as NetworkEnv;
    const apiUrl = network[env].api;

    return new NativeAuthClient({apiUrl});
}